"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * Maps array of promises that returns a Promise that is resolved
 * with an array of results when all of the provided Promises resolve,
 * or rejected when any Promise is rejected.
 *
 * @Param {Array} array       = The items to map over.
 * @Param {Function} callback = The callback to use when mapping.
 *
 */
exports.mapPromises = (array, callback) => __awaiter(this, void 0, void 0, function* () { return Promise.all(array.map(callback)); });
//# sourceMappingURL=map-promises.js.map